module.exports = __webpack_public_path__ + "img/IMG_0797.f6c91fc7.png";